import React from 'react';
import { Icon as Icons } from '@iconify/react';
const Icon = ({
  icon,
  className,
  width,
  rotate,
  hFlip,
  vFlip,
  style,
  ...rest
}) => {
  return (
    <span className="inline-flex items-center justify-center" style={style}>
      <Icons
        width={width}
        rotate={rotate}
        hFlip={hFlip}
        icon={icon}
        className={className}
        vFlip={vFlip}
        style={style}
        {...rest}
      />
    </span>
  );
};

export default Icon;
